module.exports = __webpack_public_path__ + "static/img/btn_back.b12a658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_back.png
// module id = oK1L
// module chunks = 1